export const changeSurveyPreferencesConstants = {
  GET_SURVEY_PREFERENCES: "GET_SURVEY_PREFERENCES",
  CHANGE_SURVEY_PREFERENCES: "Change Survey Preferences",
  POSITIVE_RESPONSES: "Positive Responses",
  NEGATIVE_RESPONSES: "Negative Responses",
  PASSIVE_RESPONSES: "Passive Responses",
  TURN_OFF_RESPONSES: "Turn off Responses",
  IS_POSITIVE_RESPONSE: "isPositiveResponse",
  IS_PASSIVE_RESPONSE: "isPassiveResponse",
  IS_NEGATIVE_RESPONSE: "isNegativeResponse",
  IS_TURN_OFF_RESPONSE: "isTurnOffResponse",
  CONFIRMATION_MODAL_MESSAGE: "Are you sure you want to turn off Responses?",
  CONFIRMATION_MODAL_NOTE:
    "Your preferences will be deleted. Going forward, please use the survey system to set your preferences. If you have any questions or need further assistance, feel free to reach out to our support team. Thank you!",
  EMAIL_NOTIFICATION_DESCRIPTION:
    "Receive email notifications for the following Survey responses directly to your inbox. All responses are recorded in the Survey dashboard.",
  LINK_EXPIRED_MESSAGE:
    "The link has expired. Please set preferences in the survey system.",
  /** Backend API field spelling (contract). */
  NEGATIVE_RESPONSE_ID_KEY: "nagetiveResponseId",
  POSITIVE_RESPONSE_ID_KEY: "positiveResponseId",
  PASSIVE_RESPONSE_ID_KEY: "passiveResponseId",
};

export const DEFAULT_SURVEY_PREFERENCE_CHECKBOX_STATE = {
  isPositiveResponse: false,
  isNegativeResponse: false,
  isPassiveResponse: false,
  isTurnOffResponse: false,
};
